import { Injectable, inject } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { MemberService } from '@feature/member';
import { map, Observable, switchMap } from 'rxjs';
import { BeneficiaryPolicyStatus, MemberPolicyStatusesGQL } from '../generated/shared.model';

@Injectable({
  providedIn: 'root',
})
export class SharedActivePolicyGuard implements CanActivate {
  private readonly memberPolicyStatuses = inject(MemberPolicyStatusesGQL);
  private readonly memberService = inject(MemberService);
  private readonly router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.memberService.memberId$.pipe(
      switchMap(
        (memberId: string): Observable<boolean | UrlTree> =>
          this.memberPolicyStatuses.fetch({ variables: { memberId } }).pipe(
            map((response): true | UrlTree => {
              const hasActivePolicy: boolean = response.data?.member?.beneficiaryPolicies?.some(
                ({ status }: { status: BeneficiaryPolicyStatus }): boolean => status === BeneficiaryPolicyStatus.Active,
              );

              return hasActivePolicy || this.router.createUrlTree(route.data['noPolicyRedirectUrl'] || ['/']);
            }),
          ),
      ),
    );
  }
}
